module.exports = __webpack_public_path__ + "img/POP-00010-1.9f8742b0.png";